module.exports = __webpack_public_path__ + "img/infovac-icon.6715c622.svg";